<div class="municipality-onboarding">
  <div class="header">
    <div class="search-container">
      <span class="fa fa-search"></span>
      <mat-form-field class="search-input" [floatLabel]="'never'">
        <input
          matInput
          autocomplete="off"
          [formControl]="searchField"
          (keydown.enter)="searchInputChanged($event.target.value)"
          (blur)="searchInputChanged($event.target.value)"
          placeholder="Gemeinde suchen"
        />
      </mat-form-field>
    </div>
    <button class="btn btn-outline-primary" (click)="onAddMunicipalityClick()"><span class="fa fa-plus"></span>Gemeinde hinzufügen</button>
    <div class="dropdown">
      <div dropdown>
        <mat-form-field class="form-field-class" floatLabel="never" hideRequiredMarker>
          <mat-label>Aktionen</mat-label>
          <mat-select matNativeControl required>
            <mat-option value="test" href="javascript:void(0);"> test </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </div>
  </div>

  <app-municipality-list-table [searchValue]="searchValue" [newData]="onboardingDetails" class="user-list-table"></app-municipality-list-table>
</div>
